<script>
    import Topbar from '../components/molecules/Topbar/Topbar.svelte';
	import ChatCards from '../components/organisms/ChatCards/ChatCards.svelte';
    import { user, modalCanUseHistoryBack } from '../store';
    // This checks, wether another route (like this one) was opened, before the modal was opened.
    // When opening a deeplink to a modal directly, this remains false and therefore closing the overlay will not use history.back() (e.g. to prevent going back to google.com), instead it just routes to "/"
    $modalCanUseHistoryBack = true;

    import { db, storage } from '../firebase';
    import { collectionData } from 'rxfire/firestore';
    import { startWith } from 'rxjs/operators';

    let ideas = [];
    let loading = true;

    const getAllIdeas = (entries) => {
        if (entries.length) {
            entries.forEach(async (entry, i) => {
                await getIdea(entry.idea);
            });
        }else {
            loading = false;
        }
    }
    
    const getIdea = async (ideaId) => {
        let idea;
		const docRef = db.doc(`ideas/${ideaId}`);
		docRef.onSnapshot(async (doc) => {
            if(doc.data()) {
                idea = doc.data();
                idea.id = ideaId;
                await getIdeaImageAbsolutePath(idea);
                ideas = [idea, ...ideas];
                loading = false;
            }else {
                loading = false;
            }
    	})
	}

    const getIdeaImageAbsolutePath = async (idea) => {
        const storageRef = storage.ref();
        await storageRef.child(idea.media).getDownloadURL().then((url) => { 
            idea.ideaImageAbsolutePath = url;
            return idea;
        });
    }

    // get YOUR chats
    var 	query = db.collection('chats').where('members', 'array-contains', $user.uid).orderBy('created', 'desc'),
            chats = collectionData(query, 'id').pipe(startWith([]));

    $: $chats && getAllIdeas($chats);
</script>

<Topbar title={"Joined Chats"} type={"chatCards"}></Topbar>
<ChatCards {ideas} {loading}></ChatCards>